<script setup lang="ts">
import { ref } from "vue";
import { useCustomizerStore } from "@/stores/customizer";
import { Menu2Icon } from "vue-tabler-icons";
const customizer = useCustomizerStore();
const priority = ref(customizer.setHorizontalLayout ? 0 : 0);
</script>

<template>
    <v-app-bar elevation="0" :priority="priority" height="70" id="top">
        <v-btn
            class="hidden-md-and-down custom-hover-primary me-2"
            icon
            size="small"
            color="primary"
            variant="text"
            @click.stop="() => { customizer.Sidebar_drawer = true; customizer.SET_MINI_SIDEBAR(!customizer.mini_sidebar); }"
        >
            <Menu2Icon size="20" stroke-width="1.5" />
        </v-btn>
        <v-btn
            class="hidden-lg-and-up custom-hover-primary me-2"
            icon
            variant="flat"
            @click.stop="customizer.SET_SIDEBAR_DRAWER"
            size="small"
        >
            <Menu2Icon size="20" stroke-width="1.5" />
        </v-btn>

        <!-- ---------------------------------------------- -->
        <!-- Search part -->
        <!-- ---------------------------------------------- -->
        <!-- <v-sheet class="">
      <LcFullVerticalHeaderSearchbar />
    </v-sheet> -->

        <v-spacer />
        <div class="me-2">
            <LcFullVerticalHeaderThemeToggler />
        </div>

        <!-- ---------------------------------------------- -->
        <!---right part -->
        <!-- ---------------------------------------------- -->

        <!-- ---------------------------------------------- -->
        <!-- User Profile -->
        <!-- ---------------------------------------------- -->
        <div class="ml-sm-2">
            <LcFullVerticalHeaderProfileDD />
        </div>
    </v-app-bar>
</template>
